import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DiagnosisService } from 'src/app/diagnosis.service';
import { PathologyService } from 'src/app/pathology.service';
import { PrintService } from 'src/app/print.service';

@Component({
    selector: 'app-usgeneral-print',
    templateUrl: './usgeneral-print.component.html',
    styleUrls: ['./usgeneral-print.component.scss'],
    standalone: false
})
export class UsGeneralPrintComponent implements OnInit {
  examID:number;
  PID:number;
  now:Date;
  
  Direction='ltr';
  typeOfPrint = 'simple'
  showCharts = false;
  loaded=false;
  hasImages = false;
  imPerPage = 2;
  mct = 0;
  altHeader:SafeHtml;
  showHeader = true;
  showHistory = true;
  sub: Subscription;
  groups = ['Mitral','Tricuspid','Aortic','Pulmonic','LVOT'];
  labReports: any[] = [];
  reportsLoaded = false;

  constructor(public pathologyS:PathologyService,private ds: DiagnosisService,private route: ActivatedRoute, public print:PrintService, public translate: TranslateService, private sanitizer: DomSanitizer) {
    this.now=new Date();
   }

  ngOnInit() {
    this.translate.use(this.route.snapshot.params.LANG);
    if(this.route.snapshot.params.LANG == 'he-IL' || this.route.snapshot.params.LANG == 'ar-JO')
      this.Direction='rtl';
    this.typeOfPrint = this.route.snapshot.params.style
      this.loaded=true;
    let code = this.route.snapshot.params['code'];
    this.examID = this.route.snapshot.params.examid;
    this.PID= this.route.snapshot.params.PID;
    if(this.route.snapshot.params["images"] == "y"){
      this.hasImages = true;
      this.imPerPage = this.route.snapshot.params["perpage"];
    }
    if(this.route.snapshot.params["perpage"] == "All"){
      this.hasImages = true;
      this.imPerPage = 2;
      this.print.allImages = true;
    }
    else
      this.print.allImages = false;
    if(this.route.snapshot.params.hasOwnProperty('showheader'))
      this.showHeader = this.route.snapshot.params['showheader'] == 'y';
    this.print.loadExam(this.examID,this.PID, this.hasImages,code);
    this.print.loadMsg.subscribe(()=> {
      if(this.route.snapshot.params.charts == 'y')
        this.showCharts=true;
      if(this.print.env['htmlheader']){
        this.altHeader=this.sanitizer.bypassSecurityTrustHtml(this.print.env['htmlheader']);
      }
      // Merge usGeneral into gastro for print compatibility
      this.loadLabReports();
    });
  }

  // Translates the painLevel field from the gastroProcedure table:
  translatePainLevel(value: string): string {
    let painLevel: string = "";

    if (value === "painless") {
      painLevel = "אין כאב בכלל";
    }

    if (value === "lowPain") {
      painLevel = "כאב מועט";
    }

    if (value === "mediumPain") {
      painLevel = "כאב בינוני";
    }

    if (value === "strongPain") {
      painLevel = "כאב חזק";
    }

    if (value === "fullPain") {
      painLevel = "כאב בלתי נסבל";
    }
    return painLevel;
  }

  getLabName(lab: string): string {
      switch(lab) {
        case 'patholab': return 'פטולאב';
        case 'medica': return 'מדיקה';
        case 'megalab': return 'מגהלב';
        default: return lab;
      }
    }

    loadLabReports() {
      if(! this.reportsLoaded){
        this.reportsLoaded = true
        this.pathologyS.getLabReports().subscribe((data:any[]) => {
          for(let item of data){
            if(item.ExamID == this.examID && item.Analyzed) {
              this.labReports.push(item);
            }
          }
        });
      }
    }
}
